import { Link } from "react-router";
import { Avatar } from "@/components/common/Avatar";

// A person, as the company page draws one: a rounded pill of face-and-name that links to the real
// profile — the "Klick" of the company page.
//
// THREE PLACES DREW IT AND THEY HAD ALREADY DRIFTED. The roster, the contact block and the member
// editor each spelled out the same six classes, the same Avatar and the same truncated span, and by
// the time they were gathered here they differed by exactly one thing: whether the row could be
// squeezed by controls beside it. Nobody chose that difference — it arrived when the editor's pill
// was made to stop stretching. It survives as `constrained`, which is the one honest variable, and
// everything else is now decided once.
//
// A person with no avatar falls through to Avatar's monogram, which is the same initials fallback
// §1 specifies for a company with no logo.

interface CompanyPersonPillProps {
  id: string;
  name: string | null | undefined;
  avatarContent?: string | null;
  avatarMime?: string | null;
  /**
   * True where the pill shares its row with other controls (the member editor). It then hugs its
   * content and truncates rather than pushing the controls off the row; elsewhere the pills wrap in
   * a list of their own and need no bound.
   */
  constrained?: boolean;
}

export function CompanyPersonPill({
  id,
  name,
  avatarContent,
  avatarMime,
  constrained = false,
}: CompanyPersonPillProps) {
  return (
    <Link
      id={`company-person-${id}`}
      to={`/p/${id}`}
      className={`flex items-center gap-2 rounded-full bg-ink/[0.02] py-1 pl-1 pr-3 hover:bg-ink/[0.06] ${
        constrained ? "min-w-0 max-w-full" : ""
      }`}
    >
      <Avatar person={{ name: name ?? "", avatarContent, avatarMime }} size="lg" />
      <span className="truncate text-smycles-body text-ink">{name}</span>
    </Link>
  );
}
